<template>
    <div class="notification-banners" >
        <transition-group name="banner-slide">
            <notification-banner v-for="notification in notifications"
                :key="notification.id"
                :notification="notification"
            ></notification-banner>
        </transition-group>
    </div>
</template>

<script>
import EventBus from '@/scripts/event-bus';
import NotificationBanner from '@/components/notification/notification-banner';

export default {
    props: [],

    components: {
        'notification-banner': NotificationBanner
    },

    data: function () {
        return {
            index: 1,
            notifications: []
        };
    },

    watch: {

    },

    computed: {

    },

    methods: {
        addNotification(notification) {
            notification.id = this.index;
            this.index++;

            this.notifications.push(notification);
        },

        closeNotification(notification) {
            this.notifications.splice(this.notifications.indexOf(notification), 1);
        }
    },
    
    updated () {

    },

    created () {
        EventBus.$on('show-notification', this.addNotification);
        EventBus.$on('close-notification', this.closeNotification);
    },

    beforeDestroy() {
        EventBus.$off('show-notification', this.addNotification);
        EventBus.$off('close-notification', this.closeNotification);
    }
}
</script>

<style>
.notification-banners .banner-slide-enter-active, 
.notification-banners .banner-slide-leave-active {
    transition: all .3s ease;
}

.notification-banners .banner-slide-enter, 
.notification-banners .banner-slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
    top: -100px;
}
</style>